import script from "./EditEmployee.vue?vue&type=script&setup=true&lang=js"
export * from "./EditEmployee.vue?vue&type=script&setup=true&lang=js"

import "./EditEmployee.vue?vue&type=style&index=0&id=d81362fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d81362fa"]])

export default __exports__